import { Component } from '@angular/core';
import { IAmiHead } from 'src/app/@amiga-pyme/components/ami-head/ami-head.interface';
import { ICrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.interface';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import {
  BRANCH_STORE_TTL_ES,
  IBranchStore,
  IBranchStoreTable
} from '../../branch-store.interface';
import { BranchStoreService } from '../../branch-store.service';

@Component({
  selector: 'pg-branch-store',
  templateUrl: './branch-store.component.html'
})
export class BranchStoreComponent
  extends CrudTemplate
  implements ICrudTemplate
{
  settingsAmiHead: IAmiHead = {
    title: BRANCH_STORE_TTL_ES,
    addressImg: 'branch-store'
  };
  constructor(private branchStoreService: BranchStoreService) {
    super(BRANCH_STORE_TTL_ES, branchStoreService);
  }

  ngOnInit() {
    this.table.settings = {
      title: BRANCH_STORE_TTL_ES,
      columns: [
        { header: 'Nombre', field: 'name' },
        { header: 'Código de establecimiento', field: 'establishmentCode' },
        { header: 'Dirección', field: 'address' },
        { header: 'Departamento', field: 'department' },
        { header: 'Provincia', field: 'province' },
        { header: 'Distrito', field: 'district' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.branchStoreService
      .getData$()
      .subscribe((data: IBranchStore[]) => {
        this.parseToTable(data);
      });
  }

  parseToTable(dataService: IBranchStore[]) {
    const dataTable: IBranchStoreTable[] = dataService.map((item) => {
      const { departmentId, provinceId, districtId } = item;
      return {
        ...item,
        department: this.branchStoreService.getNameDepartament(departmentId),
        province: this.branchStoreService.getNameProvince(
          departmentId,
          provinceId
        ),
        district: this.branchStoreService.getNameDistrict(
          provinceId,
          districtId
        )
      };
    });
    this.table.data = dataTable;
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
